/**
 * SCD Lot 5 — Mode formateur : scénarios de session et score composite.
 * Score = 0,4 × (trésorerie en k€) + 0,4 × (CA cumulé en k€) + 0,2 × satisfaction.
 */
import scenariosData from '../data/dgs/scenarios.json';
import secteursData from '../data/dgs/secteurs.json';

export const SCENARIOS_PRETS = scenariosData.scenarios;

export const getScenarioPret = (id) => SCENARIOS_PRETS.find(s => s.id === id) || null;

export const computeScoreComposite = ({ treasury = 0, caCumul = 0, satisfaction = 0 }) =>
  Math.round((0.4 * (treasury / 1000) + 0.4 * (caCumul / 1000) + 0.2 * satisfaction) * 10) / 10;

export const SCORE_FORMULE = 'Score = 0,4 × (trésorerie en k€) + 0,4 × (CA cumulé en k€) + 0,2 × satisfaction';

export const SECTEURS_CHOIX = secteursData.secteurs.map(s => ({ id: s.id, nom: s.nom }));

export const DIFFICULTES_CHOIX = [
  { id: 'facile', nom: 'Facile' },
  { id: 'normal', nom: 'Normal' },
  { id: 'difficile', nom: 'Difficile' },
];
